import { createApi } from '@reduxjs/toolkit/query/react'
import { NetWork } from '../../../common/apiKey'
import { GET } from '../../../common/contants'
import { axiosBaseQuery } from '../../baseQuery'

// Khớp với model.Order (chỉ các field cần dùng trong suggestion UI)
export interface SuggestionOrder {
  id: number
  code: string
  placeStart: string
  placeEnd: string
  dateStart: string | null
}

// Khớp với ProposedTripScore trong port.go
export interface ProposedTripScore {
  totalScore: number
  routeScore: number
  loadScore: number
  revenueScore: number
  timeScore: number
  routeKm: number
  detourKm: number
  utilization: number
  revenuePerKm: number
  totalRevenue: number
  estSaving: number
  reason: string
  warnings: string[]
}

// Khớp với ProposedGroupOrder trong port.go
export interface ProposedGroupOrder {
  score: ProposedTripScore
  orders: SuggestionOrder[]
  routeSequence: number[]
  suggestedCar?: { id: number; licensePlate: string }
  suggestedDate?: string | null
}

// Khớp với ConsolidateResult trong port.go
export interface ConsolidateResult {
  routeKey: string
  suggestions: ProposedGroupOrder[]
}

// Khớp với BackhaulResult trong port.go
export interface BackhaulSuggestionData {
  sourceTrip: {
    id: number
    code: string
    dateDepart: string | null
    dateReturn: string | null
    myCar: { id: number; licensePlate: string } | null
    orders: Array<{ placeStart: string; placeEnd: string; orderGroupSequence: number }>
  }
  suggestions: ProposedGroupOrder[]
}

// Keep for backwards compat (used in ConsolidationModal)
export type ConsolidationGroup = ConsolidateResult

export const tripSuggestionApi = createApi({
  reducerPath: 'tripSuggestionApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['TripSuggestion'],
  keepUnusedDataFor: 30,
  endpoints: (builder) => ({
    getBackhaulSuggestion: builder.query<{ data: BackhaulSuggestionData }, { groupOrderId: number }>({
      query: ({ groupOrderId }) => ({
        url: NetWork.tripSuggestionBackhaul,
        method: GET,
        params: { groupOrderId }
      })
    }),
    getConsolidationSuggestion: builder.query<
      { data: ConsolidateResult[] },
      { dateFrom: string; dateTo: string; myCarId?: number }
    >({
      query: ({ dateFrom, dateTo, myCarId }) => ({
        url: NetWork.tripSuggestionConsolidate,
        method: GET,
        params: { dateFrom, dateTo, ...(myCarId ? { myCarId } : {}) }
      })
    })
  })
})

export const {
  useGetBackhaulSuggestionQuery,
  useLazyGetBackhaulSuggestionQuery,
  useGetConsolidationSuggestionQuery,
  useLazyGetConsolidationSuggestionQuery
} = tripSuggestionApi
